__turbopack_context__.v({
  "bigInput": "physicalCopyForm-module-scss-module__i7DFFW__bigInput",
  "button": "physicalCopyForm-module-scss-module__i7DFFW__button",
  "folderIcon": "physicalCopyForm-module-scss-module__i7DFFW__folderIcon",
  "formSection": "physicalCopyForm-module-scss-module__i7DFFW__formSection",
  "recaptchaWrapper": "physicalCopyForm-module-scss-module__i7DFFW__recaptchaWrapper",
  "subTitle": "physicalCopyForm-module-scss-module__i7DFFW__subTitle",
  "subTitleSection": "physicalCopyForm-module-scss-module__i7DFFW__subTitleSection",
  "termsOfUse": "physicalCopyForm-module-scss-module__i7DFFW__termsOfUse",
  "textSection": "physicalCopyForm-module-scss-module__i7DFFW__textSection",
  "title": "physicalCopyForm-module-scss-module__i7DFFW__title",
});
